///include /assets/js/app/s/catalogue.js
///include /assets/js/app/s/basket.js
///include /assets/js/app/p/cloud-product-helper.js
///include /assets/js/app/p/user-contact-info.js
///include /assets/js/app/p/brand.js

"use strict"

class SShopPage {
    init() {
        const select_scroll_limit = 10;
        this.view = new Vue({
            el: "#shop-home",
            name: "page",
            data: {
                basket: AnyBasket.inst,
                brand: brand,
                categoryImages: {},
                categoryImageCalls: {},
                customProductCategories: [],
                domainSearchText: "",
                format: Site.Format,
                loading: true,
                productsAvailableByType: null,
                /** @type {{[code: string]: {link: {href: string, label: string}, title: string}}} */
                productBoxes: {
                    package: {
                        link: {
                            // See mounted hook that may change this link
                            href: "/order-hosting",
                            label: translation.get("shop_view_plans"),
                        },
                        title: translation.get("shop_webhosting"),
                        group: "group-stack_user_package_allowance",
                    },
                    cloud_server: {
                        link: {
                            href: "/build-server",
                            label: translation.get("group_cloud_server_add_title"),
                        },
                        title: translation.get("shop_cloud_servers"),
                        group: "group-cloud-server",
                    },
                    vps: {
                        link: {
                            href: "/order-vps",
                            label: translation.get("shop_view_plans"),
                        },
                        title: translation.get("shop_virtual_private_servers"),
                        group: "group-vps",
                    },
                    domain: {
                        link: {
                            href: "/domain-search",
                            label: translation.get("shop_domain_search"),
                        },
                        title: translation.get("shop_domain_names"),
                        group: "group-domain",
                    },
                    custom: {
                        link: {
                            href: "/order-additional-services",
                            label: translation.get("shop_view"),
                        },
                        title: translation.get("shop_additional_products_services"),
                        group: "group-additional",
                    },
                    stack_user_package_allowance: {
                        link: {
                            href: "/order-allowance",
                            label: translation.get("shop_order_allowance"),
                        },
                        title: translation.get("shop_order_allowance_title"),
                        group: "group-stack_user_package_allowance",
                    },
                    tls_certificate: {
                        link: {
                            href: "/order-ssl",
                            label: translation.get("shop_view_certificates"),
                        },
                        title: translation.get("shop_ssl_certificates"),
                        group: "group-tls_certificate",
                    },
                    wordpress: {
                        link: {
                            href: "/order-wordpress-hosting",
                            label: translation.get("shop_order_allowance"),
                        },
                        title: translation.get("shop_order_wordpress_title"),
                        group: "group-wordpress",
                    }
                },
                productCustomCategoryLoad: false,
                settings: SharedSettings.inst,
                userCatalogue: UserCatalogue.inst,
                userContactInfo: UserContactInfo.inst,
                get contact() {
                    return this.userContactInfo.contact
                },
                get shopIntro() {
                    var shopIntro = this.userCatalogue.shopIntro;
                    if( shopIntro && !this.contact ){
                        shopIntro.welcome = shopIntro.welcome.replace(", {{ full_name }}","").replace("{{ full_name }}","");
                    }
                    return shopIntro;
                },
                get hasQuotedProduct() {
                    if(this.userCatalogue.products){
                        return this.userCatalogue.products.filter( p => !p.discontinued && p.code.match("^bespoke:") ).filter(p => p.specifics && p.specifics.state == 'created');
                    } else {
                        return null;
                    }
                },
                /**
                 * @param {number} m
                 * @returns {string}
                 */
                intervalMonthsLabel(m) {
                    switch(m) {
                        case 1:
                            return translation.get("global_shop_per_month")
                        case 12:
                            return translation.get("global_shop_a_year")
                        default:
                            return Catalogue.intervalMonthsLabel(m)
                    }
                },
                introTemplate(template) {
                    const replacements = {
                        "{{ full_name }}": () => this.contact && this.contact.person_name,
                        "{{ brand }}": () => this.brand.brandName,
                    }
                    let s = template
                    for(const [k, f] of Object.entries(replacements)) {
                        s = s.replace(
                            k,
                            f
                        )
                    }
                    return s
                },
                /**
                 * @param {string} type
                 */
                lowestPrice(type) {
                    var allowedTypes = [type];
                    if (type.includes('custom_category')) {
                        const category = this.customProductCategories.find(e => e.category == type)
                        let productPrices = category.products.map(p => this.userCatalogue.lowestPriceOfCustomCategory(type, category.products))

                        if(!productPrices.length) productPrices = [{ price: 0 }]
                        return productPrices.reduce((prev, curr) => prev?.price < curr?.price ? prev : curr)
                    }
                    if( type == 'vps' ){
                        allowedTypes.push("managed_vps");
                    }
                    if(!this.userCatalogue.nonHidddenProducts || !this.userCatalogue.prefs) return null;
                    Vue.nextTick( () => {
                        var largest = 0;
                        $(".tombstone__footer").each(function(){
                            if ($(this).height() > largest) { largest = $(this).height(); }
                        });
                        $(".tombstone__footer").height(largest);
                    });
                    if (type === 'wordpress') {
                        const products = this.userCatalogue.nonHidddenProducts.filter(p => {
                            return p.platform == 'wordpress'
                        })

                        if(!products.length) return [{ price: 0 }]
                        const lowerPrice = products.reduce((prev, curr) => prev.price < curr.price ? prev : curr)
                        return lowerPrice.pricing.reduce((p, c) => p.price < c.price ? p : c)
                    }
                    if (
                        type == 'stack_user_package_allowance' &&
                        this.settings.config?.prefs?.splitWordpressHosting
                    ) {
                        const products = this.userCatalogue.nonHidddenProducts.filter(p => {
                            return p.codePrefix == type && p.platform !== 'wordpress'
                        })

                        if(!products.length) return [{ price: 0 }]
                        const lowerPrice = products.reduce((prev, curr) => prev.price < curr.price ? prev : curr)
                        return lowerPrice.pricing.reduce((p, c) => p.price < c.price ? p : c)
                    }
                    if( (type == 'package' || type == 'vps' || type == 'stack_user_package_allowance') && this.userCatalogue.prefs.advertiseMonthlyEquivalent ){
                        var productsByType = this.userCatalogue.nonHidddenProducts.filter( p => allowedTypes.includes(p.codePrefix) && p.codePrefix != 'managed_vps' );
                        var p = [];
                        if(productsByType.length > 0){
                            for(const x of productsByType){p = p.concat(x.pricing) }
                            p.sort( (a,b) => { return (a.price / a.periodMonths) - (b.price / b.periodMonths); } );
                            return p[0];
                        }
                        return 0;
                    } else {
                        var pc = this.userCatalogue.lowestPriceOfType(type);
                        if( type == 'vps' ){
                            var mpc = this.userCatalogue.lowestPriceOfType("managed_vps");
                            if( !pc && mpc ){
                                return mpc;
                            } else if (!mpc && pc) {
                                return pc;
                            } else {
                                // We have both
                                if( pc.price < mpc.price ){
                                    return pc;
                                } else {
                                    return mpc;
                                }
                            }
                        }
                        return pc;
                    }
                },
                /**
                 * @param {string} type
                 */
                productDescription(type) {
                    const group = `group-${type}`
                    return(
                        this.userCatalogue.productDescriptionFromCode(group, translation.getActiveLanguage()) ||
                        Catalogue.defaultProductDescription(group).content
                    )
                }
            },
            watch: {
                "userCatalogue.productDescription": function(n,o){
                    if( n ) {
                        Vue.nextTick( () => {
                            var largest = 0;
                            $(".description-container").each(function(){
                               if ($(this).height() > largest) { largest = $(this).height(); }
                            });
                            $(".description-container").height(largest);
                        });
                    }
                },
                loading(v) {
                    if(!v) {
                        Vue.nextTick( () => {
                            $( ".page-loaded-content" ).fadeTo(200,1, function() {});
                        });
                    }
                },
            },
            computed: {
                /**
                 * @returns {boolean}
                 */
                contactFormAvailable() {
                    if( this.brand && this.brand.togglePrefs ){
                        return this.brand.togglePrefs.contactForm;
                    }
                },
                resultingPrice() {
                    return type => {
                        const priceData = this.lowestPrice(type)
                        if (priceData.isManaged) {
                            return priceData.managedMarkedUpPrice
                        }

                        return priceData.price
                    }
                }
            },
            methods: {
                /**
                 * FIXME temp solution, productBoxes needs to be swapped to
                 * use SBCategory at some point.
                 */
                async imageForCategory(type) {
                    if (this.categoryImageCalls[type]) return;
                    try {
                        const customCat = type.startsWith('custom_category_');
                        const categoryType = customCat
                            ? type.replace('custom_category_', '')
                            : type;

                        const image = await $.ajax(`/a/catalogue/categoryImage/${customCat ? '' : 'group-'}${categoryType}`);
                        this.categoryImages[type] = image;
                    } catch(e) {
                        console.error(e);
                    }
                    // Hack to prevent multiple API calls on re-renders
                    this.categoryImageCalls[type] = true;
                },
                isHiddenDefaultCategory(categoryGroup) {
                    const hiddenDefaultCategories = this.userCatalogue?.config?.hiddenDefaultCategories ?? [];
                    if (this.userCatalogue?.config?.prefs?.splitWordpressHosting == false) {
                        hiddenDefaultCategories.push("group-wordpress");
                    }
                    return hiddenDefaultCategories.includes(categoryGroup);
                },
                productCountCheck(type) {
                    if (type.includes('custom_category')) return true
                    switch(type) {
                        case 'custom_limit_addon':
                        case 'package':
                            if (this.productsAvailableByType['package'].constructor === Array) {
                                if (this.productsAvailableByType['package'].length === 0) {
                                    return false
                                }
                            }

                            for(const p in this.productsAvailableByType[type]){
                                if( this.productsAvailableByType[type][p] ){
                                    return true;
                                }
                            }
                            break;
                        case 'stack_user_package_allowance':
                            if (this.productsAvailableByType['stack_user_package_allowance'].constructor === Array) {
                                if (this.productsAvailableByType['stack_user_package_allowance'].length === 0) {
                                    return false
                                }
                            }
                            return true;
                            break;
                        case 'wordpress':
                            if (
                                !this.productsAvailableByType['stack_user_package_allowance'] ||
                                !this.productsAvailableByType['stack_user_package_allowance']['wordpress']
                            ) {
                                return false
                            }
                        default:
                            return true;
                    }
                    return false;
                },
                searchForDomain() {
                    location.href =
                        "/domain-search?" +
                        $.param({domain: this.domainSearchText})
                },
                getCustomCategoryProductTypes(category) {
                    if (this.customProductCategories.length) {
                        const cat = this.customProductCategories.find(e => e.category == category)
                        const productCodePrefixArr = cat.products.map(p => {
                            const product = this.userCatalogue.products.find(pr => {
                              return pr.code == p
                            })
                            return product ? product.codePrefix : null
                        })

                        return [...new Set(productCodePrefixArr)].filter(el => el !== null)
                    }
                },
                isVisible(type) {
                    if (type.includes('custom_category')) {
                        return this.customProductCategories.find(c => c.category == type).visible
                    }

                    return true
                },
                productAvailabiltyCheck(type) {
                    if (
                        this.productsAvailableByType &&
                        this.productsAvailableByType[type] &&
                        this.productCountCheck(type) &&
                        this.isVisible(type)
                    ) {
                        return true
                    }

                    if (type === 'wordpress') {
                        if (
                            this.productsAvailableByType?.stack_user_package_allowance?.wordpress &&
                            this.productCountCheck(type) &&
                            this.isVisible(type)
                        ) {
                            return true
                        }
                    }

                    return false
                }
            },
            async mounted() {
                CloudProductHelper.inst;
                await this.userCatalogue.assertExists();
                await this.settings.preload(["config", "contact"]);
                await this.userCatalogue.preloadSingle("isOpen");
                await Promise.all([
                    $.ajax(`/a/catalogue/_design/product/_view/byType`),
                    $.ajax(`/a/catalogue/productCustomCategory`),
                ]).then(vals => {
                    let r = vals[0];
                    let s = vals[1];
                    if( r.managed_vps && !r.vps ){
                        r.vps = r.managed_vps;
                    }
                    var forSaleByType;
                    var planOnly = false;
                    if( r.package.length > 0 ){
                        forSaleByType = Object.keys(r.package);
                    } else {
                        forSaleByType = Object.keys(r.stack_user_package_allowance);
                        planOnly = true;
                    }
                    if( planOnly ){
                        this.productBoxes.stack_user_package_allowance.link.href = this.productBoxes.package.link.href;
                        this.productBoxes.stack_user_package_allowance.title = this.productBoxes.package.title;
                    }
                    if(
                        this.settings.config.prefs &&
                        this.settings.config.prefs.splitWordpressHosting &&
                        forSaleByType.length == 1 &&
                        forSaleByType[0] == 'wordpress'
                    ){
                        if( planOnly ){
                            this.productBoxes.stack_user_package_allowance.link.href = "/order-wordpress-hosting";
                        }
                        this.productBoxes.package.link.href = "/order-wordpress-hosting";
                    }
                    this.productsAvailableByType = r;

                    s.forEach((e, i) => {
                        e.category = `custom_category_${e.id}`
                        this.customProductCategories.push(e)
                        this.productsAvailableByType[`custom_category_${e.id}`] = true
                        this.productBoxes[`custom_category_${e.id}`] = {
                            link: {
                                href: `/pccategory?cat=${e.id}`,
                                label: e.linkText
                            },
                            title: e.label,
                            description: e.description
                        }
                    })
                    this.productCustomCategoryLoad = true

                    const category_order = this.settings.config.categoryOrder;

                    if (category_order) {
                        this.productBoxes = Object.keys(this.productBoxes).sort((a, b) => {
                            //  Check if string includes custom_category_ if so remove it when checking for index
                            const indexA = category_order.indexOf(a.replace('custom_category_', ''));
                            const indexB = category_order.indexOf(b.replace('custom_category_', ''));

                            if (indexA < indexB) return -1;
                            if (indexA > indexB) return 1;
                            return 0;
                        }).reduce(
                            (obj, key) => {
                              obj[key] = this.productBoxes[key];
                              return obj;
                            },
                            {}
                        );
                    }
                });

                this.loading = false
            },
            components: {
                shopNav: ShopNav,
                vueSelect: VueSelect,
            },
        })
    }
}
